import { render, staticRenderFns } from "./FeedbackEnd.vue?vue&type=template&id=41b13c39&scoped=true&"
import script from "./FeedbackEnd.vue?vue&type=script&lang=js&"
export * from "./FeedbackEnd.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackEnd.vue?vue&type=style&index=0&id=41b13c39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b13c39",
  null
  
)

component.options.__file = "FeedbackEnd.vue"
export default component.exports